core.config(['$stateProvider', '$urlRouterProvider',
    function ($stateProvider, $urlRouterProvider) {

        // layout
        //
        //$stateProvider.state(Constant.LAYOUT.RAW, {
        //    abstract: true,
        //    templateUrl: 'application/view/raw.html'
        //});
        //
        //$stateProvider.state(Constant.LAYOUT.PRE, {
        //    abstract: true,
        //    templateUrl: 'application/view/pre.html'
        //});
        //
        //$stateProvider.state(Constant.LAYOUT.APP, {
        //    abstract: true,
        //    controller: 'mainController',
        //    templateUrl: 'application/view/app.html'
        //});

}]);